var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"website"}},[_c('full-page',{ref:"fullpage",attrs:{"options":_vm.options,"id":"fullpage"}},[_c('div',{staticClass:"section"},[_c('swiper')],1),_c('div',{staticClass:"section"},[_c('section2',{ref:"section2",attrs:{"curIndex":_vm.curIndex}})],1),_c('div',{staticClass:"section"},[_c('section5')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }